module.exports = function getResource(label) {
    const resources = {
        seeMore: 'Voir plus',
        showMore: 'Afficher plus'
    };
    return resources[label];
};
